export default "__VITE_ASSET__aiWYcivv__"